import { render, staticRenderFns } from "./PlanHistoryValuesTable.vue?vue&type=template&id=64693a18"
import script from "./PlanHistoryValuesTable.vue?vue&type=script&lang=js"
export * from "./PlanHistoryValuesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports